import { ComponentProps, ComponentPropDefinitionUtil, ComponentPropDefinitions } from "../../base/ComponentProps";

export interface StyledEditorProps extends ComponentProps {
}

let styledEditorProps: ComponentPropDefinitions

export class StyledEditorPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (styledEditorProps == null) {
      styledEditorProps = {
        ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
      };
    }
    return styledEditorProps;
  }
}
